import React from 'react';
import PropTypes from 'prop-types';

import { Arrow, Message } from './components';

const InputMessageBaseProps = {
  children: PropTypes.node,
  backgroundColor: PropTypes.string,
};

const InputMessage = ({ children, backgroundColor }) => (
  <>
    <Arrow borderColor={backgroundColor} />
    <Message backgroundColor={backgroundColor}>{children}</Message>
  </>
);

InputMessage.propTypes = InputMessageBaseProps;

export default InputMessage;
